import React from 'react';

import Footer from './Footer';
import Subsection from './Subsection';
import { useSidebarRight } from '../Provider';
import { Body, Header, Wrapper } from '../Layout';

type Props = {
  onClose: () => void;
  integrationId: ID;
};

function Versioning({ integrationId, onClose }: Props) {
  const { activeSubsection, sectionContext } = useSidebarRight();

  const isPromoteSection = activeSubsection === 'promote';

  return (
    <Wrapper>
      {!isPromoteSection && <Header onClose={onClose} title="Versioning" />}
      <Body>
        <Subsection
          integrationId={integrationId}
          onClose={onClose}
          sectionContext={sectionContext}
          sectionId={activeSubsection}
        />
        {isPromoteSection && <Footer sectionId={activeSubsection} />}
      </Body>
      {!isPromoteSection && <Footer sectionId={activeSubsection} />}
    </Wrapper>
  );
}

export default Versioning;
